<template>
    <div :id="paymentMethodName" v-show="isAvailable">
        <empty-state
            v-if="paymentProcessing"
            class="overlay fullscreen"
            statusIcon="loading"
            title="Processing your payment"
            subtitle="Please do not refresh the page"
        ></empty-state>
        <div class="selectable-card collapsable-card"
             :class="{ 'active' : paymentMethodIsSelected(paymentMethodName) }">
            <div class="card-body">
                <div class="card-header"
                     @click="setPaymentMethod(paymentMethodName)"
                     v-scroll-to="{
                        el: '#'+paymentMethodName,
                        offset: -94,
                    }">
                    <p>
                        Pay 3 interest-free instalments
                    </p>
                    <img src="https://res.cloudinary.com/wefix/image/upload/v1567427800/booking/klarna.svg" alt="Klarna" class="payment-type-icon" />
                </div>
                <div class="collapse" :class="{ 'show': paymentMethodIsSelected(paymentMethodName) }">
                    <div class="collapse-body">
                        <div class="collapse-content">
                            <div id="klarna-pay-in-three-container"></div>
                            <!-- Total Cost -->
                            <div class="col-12">
                                <table class="price-table grand-total">
                                    <tr class="total-cost">
                                        <td>Total:</td>
                                        <td><span v-html="currencySymbol"></span>{{ cartTotal }}</td>
                                    </tr>
                                </table>
                            </div>
                            <button @click="submit()" class="btn btn-block btn-lg btn-rounded continue-btn mb-3" :disabled="isLoading">
                                <span v-show="isLoading">
                                    <i class="fa fa-spinner fa-pulse"></i>
                                </span>
                                Complete booking
                            </button>
                            <div class="text-center" v-if="isBookingInStore">
                                <p class="mt-4 mb-2 text-sm">
                                    By completing your order, you agree to our <router-link :to="{name: 'Terms'}" target="_blank">terms and conditions</router-link> and <router-link :to="{name: 'Privacy'}" target="_blank">privacy policy</router-link>.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    /* global Klarna */
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "KlarnaInstalmentsPaymentMethod",

        props: [
            "isSelected"
        ],

        data() {
            return {
                paymentMethodName: "klarna-instalments",
                hasInitialised: false,
                isAvailable: false,
                isLoading: false,
                paymentProcessing: false,
            }
        },

        mounted() {
            if(this.klarnaSdkIsAvailable) {
                this.initialise();
            }
        },

        computed: {
            ...mapGetters([
                "booking",
                "cartTotal",
                "isBookingInStore",
                "klarnaSdkIsAvailable",
                "paymentMethodIsSelected",
                "currencySymbol"
            ]),
        },

        methods: {
            ...mapActions([
                "setPaymentMethod",
                "setCustomerDetails",
                "chargeBooking",
                "displayToastFromResponseObjectOfErrors",
                "updateKlarna",
                "retrieveBooking"
            ]),

            initialise() {
                let self = this;
                Klarna.Payments.load({
                    container: '#klarna-pay-in-three-container',
                    payment_method_category: 'pay_over_time'
                }, response => {
                    self.isAvailable = (self.cartTotal < 35) ? false : response.show_form ;
                });
            },

            submit() {
                let self = this;
                self.isLoading = true;
                self.paymentProcessing = true;
                self.setCustomerDetails({
                    force_persist: true
                }).then(() => {
                    this.updateKlarna().then(() => {
                        Klarna.Payments.authorize({
                            payment_method_category: "pay_over_time"
                        }, {}, response => {
                            if (response.approved) {
                                self.chargeBooking({
                                    paidViaCredit: true,
                                    paymentType: "klarna",
                                    token: response.authorization_token
                                }).then(() => {
                                    self.isLoading = false;
                                    self.paymentProcessing = false;

                                    self.$router.push({name: 'bookingComplete'});
                                }).catch(errors => {
                                    self.isLoading = false;
                                    self.paymentProcessing = false;

                                    if (errors.response.data.code === 'BK27') {
                                        self.retrieveBooking().then(() => {
                                            self.$router.push({name: 'checkout'});
                                        });

                                    } else if (errors.response.data.code === 'RBK15') {
                                        self.$emit("iwOrderIsOow");

                                    } else {
                                        self.displayToastFromResponseObjectOfErrors(errors);
                                    }
                                });
                            } else {
                                self.isLoading = false;
                                self.paymentProcessing = false;
                            }

                            self.isAvailable = response.show_form;
                        });
                    });
                })
            }
        },

        watch: {
            klarnaSdkIsAvailable(newValue) {
                if(newValue === true && this.hasInitialised === false) {
                    // The SDK is now available to use and the widget hasn't already been initialised
                    this.initialise();
                }
            }
        }
    }
</script>

<style scoped>

</style>